export default "a-default";



// WEBPACK FOOTER //
// ./src/mod1.js